import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: rgb(255, 255, 255);
  .ecr-slider-wrapper {
    text-align: center;
    max-width: 1000px;
    li {
      list-style: none;
    }
    img {
      width: 100%;
    }
  }
`;
